import React from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav class="bg-white border-gray-200 dark:bg-gray-900">
    <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 pr-14">
        <a class="flex items-center space-x-3 rtl:space-x-reverse">
            <img src="./logo.svg" class="h-12" alt="Career Compass" />
            <span class="self-center text-2xl font-semibold whitespace-nowrap"></span>
        </a>
        <button data-collapse-toggle="navbar-default" type="button" class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200" aria-controls="navbar-default" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
            </svg>
        </button>
        <div class="hidden w-full md:block md:w-auto" id="navbar-default">
        <ul class="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white">
            <li>
            <Link to="/" className="block py-2 px-3 text-black rounded md:bg-transparent md:p-0 hover:text-[#F4CE14]"
                aria-current="page">
                Home</Link>
            </li>

            <li>
            <Link to="/job-vacancy" className="block py-2 px-3 text-black rounded md:bg-transparent md:p-0 hover:text-[#F4CE14]"
                aria-current="page">
                Vacancy</Link>
            </li>

            <li>
            <ScrollLink
            to="contact"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="block py-2 px-3 text-black rounded md:bg-transparent md:p-0 hover:text-[#F4CE14] cursor-pointer"
            >
            Contact
            </ScrollLink>
            </li>
        </ul>
        </div>
    </div>
    </nav>
  );
};

export default Navbar;
